import React from 'react';
import PropTypes from 'prop-types';
import {Input} from 'reactstrap';

const DefaultInput = ({inputValue, onChange, placeholder, inputName, inputType, validation}) => {
  const customProps = () => {
    if(typeof validation !== 'object') return {};
    const localValidation = validation.find(v => v.key === inputName);

    if(!localValidation) return {};
    return localValidation.valid ? {valid: true} : {invalid: true};
  };

  return (
    <Input
      type={inputType}
      name={inputName}
      id={inputName}
      placeholder={placeholder}
      onChange={onChange}
      value={inputValue}
      {...customProps()} />
  );
};

DefaultInput.defaultProps = {
  placeholder: 'John Doe',
  inputType: 'text',
  validation: []
};

DefaultInput.propTypes = {
  inputValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputName: PropTypes.string.isRequired
};

export default DefaultInput;